module.exports = __webpack_public_path__ + "img/1481151339.aff851d8.jpg";